import React from "react";
import { useTranslateKey, T } from "../../hooks/useTranslate";
import { styles } from "../../screens/PartnersScreen/partners.styles";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  Checkbox,
} from "@mui/material";
import ViewWeekOutlinedIcon from "@mui/icons-material/ViewWeekOutlined";
import { columns } from "../../screens/MyMembersScreen/format-members-columns";
import { useMixPanel } from '../../hooks/useMixPanel';


const ManageColumnsMobile = ({
  loading,
  columnVisibility,
  setColumnVisibility
}) => {
  const [columnAnchorEl, setColumnAnchorEl] = React.useState(null);
  const manageColumnOpen = Boolean(columnAnchorEl);
  const { logEvent } = useMixPanel();

  const translateKey = useTranslateKey;

  // toggle the boolean stored in column visibility
  const handleManageColumnClick = (e) => {
    const newObj = { ...columnVisibility };
    const currentField = e.currentTarget.getAttribute("value");

    newObj[currentField] = !columnVisibility[currentField];
    setColumnVisibility(newObj);
    logEvent("column_visibility_change", {
      location: "members",
      columnVisibilityModel: newObj
    });
  };

  const handleButtonClick = (event) => {
    const target = event.currentTarget;
    setColumnAnchorEl(target);
  };

  const handleClose = () => {
    setColumnAnchorEl(null);
  };

  const subheaderStyle = {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: 10,
    color: "#8A9BB0",
    padding: "16px 24px 0px 26px",
  };

  const textStyle = {
    fontFamily: "Inter",
    fontWeight: "500",
    fontSize: "14px"
  }
  return (
    <Box>
      <IconButton
        aria-label="open manage columns"
        id="manage-column-button"
        aria-controls={manageColumnOpen ? "manage-column-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={manageColumnOpen ? "true" : undefined}
        disabled={loading}
        onClick={handleButtonClick}
        style={manageColumnOpen ? styles.selectedIcon : undefined}
        sx={{
          border: "1px solid rgba(145, 158, 171, 0.2)",
          borderRadius: "8px",
          paddingTop: "9px",
          paddingBottom: "9px"
        }}
      >
        <ViewWeekOutlinedIcon />
      </IconButton>
      <Menu
        id="manage-column-menu"
        anchorEl={columnAnchorEl}
        open={manageColumnOpen}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "manage-column-button",
        }}
        PaperProps={{
          style: {
            width: "100%",
            marginTop: "8px",
            borderRadius: "8px",
            border: "1px solid rgba(145, 158, 171, 0.1)",
            boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(145, 158, 171, 0.1)'
          },
        }}
      >
        <Box sx={subheaderStyle}><T isUpperCase={true}>manage_columns</T></Box>
        {columns.filter(c => !c.hideFromGrid).map(column => (
          <MenuItem
            aria-label={column.headerName}
            key={column.headerName}
            value={column.field}
            data-test-id={`manage-columns-${column.headerName}`}
            onClick={handleManageColumnClick}
            disabled={column.field === "name" ? true : loading}
          >
            <Checkbox
              checked={columnVisibility[column.field] === true}
              disabled={
                column.field === "name" ? true : loading
              }
            />
            <ListItemText primary={translateKey(column.headerName)} primaryTypographyProps={textStyle} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}

export { ManageColumnsMobile }
